<template>
  <div>
    <b-row>
      <b-col>
        <b-tabs pills content-class="mt-4" @activate-tab="updateUrl">
          <b-tab
            v-for="tab in tabs"
            :key="tab.slug"
            :title="tab.title"
            :active="$route.params.tab === tab.slug"
          >
            <component :is="tab.component" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Attachments from './Partials/_Attachments.vue';
import ApiTokens from './Partials/_ApiTokens.vue';
import Exact from './Partials/_Exact.vue';
import Exports from './Partials/_Exports.vue';
import Settings from './Partials/_Settings.vue';
import Transmission from './Partials/_Transmission.vue';
import Whitelist from './Partials/_Whitelist.vue';

export default {
  data() {
    return {
      tabs: [
        {
          title: 'Instellingen',
          slug: 'instellingen',
          component: Settings,
        },
        {
          title: 'Exports',
          slug: 'exports',
          component: Exports,
        },
        {
          title: 'Exact',
          slug: 'exact',
          component: Exact,
        },
        {
          title: 'Transmission',
          slug: 'transmission',
          component: Transmission,
        },
        {
          title: 'Whitelist',
          slug: 'whitelist',
          component: Whitelist,
        },
        {
          title: 'API Tokens',
          slug: 'api-tokens',
          component: ApiTokens,
        },
        {
          title: 'Mail bijlagen',
          slug: 'mail-bijlagen',
          component: Attachments,
        },
      ],
    };
  },

  methods: {
    updateUrl(newTabIndex) {
      this.$router.push({
        name: 'management.index',
        params: { tab: this.tabs[newTabIndex].slug },
      });
    },
  },
};
</script>
